import type { ReactElement } from 'react'
import { NotReady, RelativeDateWithTooltip, PrefetchedUserInfo, Page } from '@components'
import { useVideoReports } from '@front/model'
import { useNavigate, createFileRoute } from '@tanstack/react-router'
import { getCreatedAt } from '@terros/common'
import { DataTable } from 'mantine-datatable'

function ShortsReportsPage(): ReactElement {
  const { data, isLoading, error, refetch, isFetching } = useVideoReports()
  const navigate = useNavigate()

  if (isLoading || error || !data) return <NotReady data={data} error={error} id='Reports' isLoading={isLoading} />

  return (
    <Page>
      <Page.Heading isFetching={isFetching} refetch={refetch} title='Review Shorts' />
      <Page.Content>
        <DataTable
          idAccessor='videoId'
          records={data}
          columns={[
            { accessor: 'videoId', title: 'Video ID' },
            {
              accessor: 'owner',
              title: 'Owner',
              render: ({ owner }) => <PrefetchedUserInfo user={owner} />,
            },
            { accessor: 'reportCount' },
            {
              accessor: 'createdAt',
              title: 'Created',
              render: (video) => {
                const createdAt = getCreatedAt(video)
                if (!createdAt) return
                return <RelativeDateWithTooltip calendar date={createdAt} />
              },
            },
            {
              accessor: 'updatedAt',
              title: 'Updated',
              render: ({ updatedAt }) => {
                if (!updatedAt) return
                return <RelativeDateWithTooltip calendar date={updatedAt} />
              },
            },
          ]}
          onRowClick={({ record: { videoId } }) => navigate({ to: `/short/reports/${videoId}` })}
        />
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/short/reports/')({
  component: ShortsReportsPage,
})
